import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const ReportList = ({ data, activeTab }) => {
  const navigate = useNavigate();

  const handleUserProfile = (user) => {
    navigate("/admin/user/userDetails", { state: { userId: user._id } });
  };

  const handleContentClick = (report) => {
    const contentId = report?.content?.details?._id;

    if (!contentId) {
      toast.error("No valid content ID found.");
      return;
    }

    if (activeTab === "post") {
      navigate("/admin/post/postDetails", {
        state: { postId: contentId, fromReport: true, report },
      });
    } else if (activeTab === "blog") {
      navigate("/admin/blog/blogDetails", {
        state: { blogId: contentId, fromReport: true, report },
      });
    } else if (activeTab === "story") {
      navigate("/admin/story/storiesdetails", {
        state: { storyId: contentId, fromReport: true, report },
      });
    }
  };

  const filteredData = data?.filter((report) => report?.content?.type === activeTab);

  return (
    <div className="overflow-x-auto pt-4 pb-4">
      {filteredData?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredData.map((report) => (
            <div
              key={report._id}
              className="bg-white border p-4 rounded-2xl shadow transition-shadow duration-300 ease-in-out hover:shadow-lg cursor-pointer flex flex-col"
            >
              <div
                onClick={() => handleUserProfile(report.user)}
                className="flex items-center gap-4 mb-3 cursor-pointer"
              >
                <img
                  src={report.user.profileImage}
                  alt={report.user.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="font-medium text-gray-700 capitalize">{report.user.userName}</div>
              </div>
              <div>
                {report?.content?.storyImage && (
                  <img src={report.content.storyImage} alt="Story" className="w-20 h-20 rounded-md object-cover" />
                )}
              </div>
              <div className="mb-3">
                <div className="font-semibold text-lg capitalize">Report: {report.report}</div>
              </div>
              <div className="text-gray-600 text-base line-clamp-1 capitalize mb-3">
                {report?.content?.details?.title}
              </div>
              <div className="flex justify-between items-center">
                <p className="text-sm text-light">{moment(report.createdAt).fromNow()}</p>
                <button
                  onClick={() => handleContentClick(report)}
                  className="bg-primary text-white text-sm sm:text-base font-semibold py-1 px-3 rounded-lg transition-colors duration-300 hover:bg-blue-600"
                >
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 items-center h-[calc(100vh-200px)] w-full">
          <p className="text-center text-gray-500 text-lg">No reports found.</p>
        </div>
      )}
    </div>
  );
};
